'use strict';

angular.module('atex.dam').factory('DamUrlSearchService', [
function() {

  return {
    getQParam: function methodThatDoesAThing() {
      var q = gup('q',window.location.href);
      if(q!==null){
          return JSON.parse(decodeURIComponent(q));
        }
      else{
        return null;
      }
    },
    getTypeParam: function methodThatDoesAThing() {
      var type = gup('type',window.location.href);
      if(type!==null){
        return type;
      }
      else{
        return null;
      }
    }
  };
}]);
//function for the exraction of the string pram from the browser irl
function gup( name, url ) {
  if (!url) {url = location.href;}
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec( url );
  return results === null ? null : results[1];
}